import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { DialogOptions } from 'src/app/interfaces/dialog-data.interface';
import { OnGetData } from 'src/app/services/dialog.service';
import { GalleryService } from 'src/app/services/gallery.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-delete-gallery-dialog',
  templateUrl: './delete-gallery-dialog.component.html',
  styleUrls: ['./delete-gallery-dialog.component.scss'],
  standalone: true,
  imports: [SvgComponent, ButtonDirective, NgIf, LoadingIndicatorComponent],
})
export class DeleteGalleryDialogComponent implements OnGetData {
  dialogName = 'delete-gallery';
  close: (...args) => void;
  gallery: GalleryDto;
  loading = false;

  constructor(private galleryService: GalleryService) {}

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40, hasSmallBottomPart: true };
  }

  onGetData(data: { gallery: GalleryDto }, close: (...args) => void) {
    this.gallery = data.gallery;
    this.close = close;
  }

  async confirm() {
    if (this.loading) return;
    this.loading = true;
    await this.galleryService.deleteGallery(this.gallery.id);
    this.close(true);
  }
}
